import React from 'react';
import './sheet.css';

/**
 * «Προεπιλογή εφαρμογής · Μπλε» / «Όπως ο οργανισμός · Κίτρινο»: η επιλογή «κληρονομείται» ενός
 * πεδίου, σε δύο γραμμές (χωρά στη στενή αριστερή στήλη). Εγγενές radio με το ίδιο `name` με τις
 * υπόλοιπες επιλογές του πεδίου, ώστε βελάκια και αναγνώστες οθόνης να τη βλέπουν ως μία ομάδα.
 */
export interface SheetInheritProps {
  name: string;
  checked: boolean;
  onSelect: () => void;
  label: React.ReactNode;
  /** Τι κληρονομείται (δεύτερη γραμμή). */
  value?: React.ReactNode;
  /** Δείγμα χρώματος (hex) πριν από το κείμενο. */
  swatch?: string;
  disabled?: boolean;
  testId?: string;
}

export const SheetInherit: React.FC<SheetInheritProps> = ({ name, checked, onSelect, label, value, swatch, disabled = false, testId }) => (
  <label className="xs-inherit" data-testid={testId}>
    <input type="radio" name={name} className="sr-only" checked={checked} disabled={disabled} onChange={onSelect} />
    <span className="xs-inherit-box">
      <span className="xs-radio" aria-hidden="true" />
      {swatch && <span className="xs-inherit-swatch" aria-hidden="true" style={{ background: swatch }} />}
      {/* Το κενό ανάμεσα δεν φαίνεται (flex) αλλά χωρίζει τις λέξεις στο όνομα του radio. */}
      <span className="xs-inherit-lines">
        <span>{label}</span>
        {value && <>{' '}<span className="xs-inherit-sub">{value}</span></>}
      </span>
    </span>
  </label>
);

export default SheetInherit;
